import { Button, Box } from "@mui/material";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState, useRef } from "react";
import { stepAction, setUserAction } from "redux/reducers/join";
import { useParams, useHistory } from "react-router-dom";
import AlertComplete from "components/ui/alert-complete";
import AlertConfirm from "components/ui/alert-confirm";
import { goCert, isJsonString } from "assets/js/common";
import { loginRequestAction, setUserInfoAction } from "redux/reducers/user";
import jwt_decode from "jwt-decode";
import { Cookies } from "react-cookie";
import { setInitCookies } from "assets/js/common";
const cookies = new Cookies();

export default function JoinStep1(props) {
  const dispatch = useDispatch();
  const history = useHistory();
  const { loginSuccess, loginResponseData } = useSelector(
    (state) => state.user
  );
  const [userInfo, setUserInfo] = useState("");
  const { user } = useSelector((state) => state.join);
  const [open, setOpen] = useState(false);
  const [mode, setMode] = useState("");
  const [data, setData] = useState("");
  const handleAlertClose = () => {
    setOpen(false);
  };

  const handleAlertOpen = (mode, item) => {
    setMode(mode);
    setOpen(true);
    setData(item);
  };

  const setReturnData = (result) => {
    result = JSON.parse(result);
    if (result.rst == "success") {
      if (result.isDuplInfo == "true") {
        handleAlertOpen("isDuplInfo");
      } else if (result.isUser === "true") {
        if (result.isLev === "true") {
          handleAlertOpen("isLev", result);
        } else {
          handleAlertOpen("isUser", result);
        }
      } else if (result.isOrgUser === "true") {
        handleAlertOpen("isOrgUser", result);
      } else {
        dispatch(
          setUserAction({
            ...user,
            ...result,
          })
        );
        dispatch(stepAction(2));
        history.push("/join/2");
      }
    }
  };

  const handleAlreadyUser = () => {
    dispatch(
      setUserAction({
        ...user,
        ...data,
      })
    );
    dispatch(stepAction(2));
    history.push("/join/2");
  };

  const goLogin = (data) => {
    let form = {
      grantType: "cert",
      ci: data.ci,
    };

    dispatch(loginRequestAction(form));
    // axios.post("/api/auth/token", form).then((res) => {
    //   window.loginComplete = function(authKey, pushUrl) {
    //     history.push("/");
    //   };

    //   if (window.Android) {
    //     window.Android.login(data.no, "loginComplete");
    //   } else if (
    //     window.webkit &&
    //     window.webkit.messageHandlers &&
    //     window.webkit.messageHandlers.ios
    //   ) {
    //     // Call iOS interface
    //     var message = {
    //       command: "login",
    //       id: data.no,
    //       func: "loginComplete",
    //     };
    //     window.webkit.messageHandlers.ios.postMessage(message);
    //   }
    //   history.push("/");
    // });
  };

  // sorry... no redux reset
  const onReset = () => {
    dispatch(
      setUserAction({
        no: "",
        nm: "",
        birth: "",
        gender: "",
        cph: "",
        di: "",
        ci: "",
        isOrgUser: "",
        isUser: "",
        pwd: "",
        pwdChk: "",
        email: "",
        zip: "",
        addr: "",
        addrDtl: "",
        allYn: "N",
        tncYn: "N",
        plcyYn: "N",
        pushYn: "N",
        mktYn: "N",
        mktPushYn: "N",
        mktSmsYn: "N",
        mktEmailYn: "N",
        gnrPushYn: "Y",
        favMt: "",
        mblRctYn: "N",
        mainTp: "1",
      })
    );
  };

  useEffect(async () => {
    let cookieExpires = new Date();
    cookieExpires.setDate(cookieExpires.getDate() + 180);

    if (loginSuccess) {
      const myDecodedToken = jwt_decode(loginResponseData.accessToken);
      dispatch(setUserInfoAction(myDecodedToken));

      axios.defaults.headers.Authorization = `${loginResponseData.tokenType} ${
        loginResponseData.accessToken
      }`;

      //   setAppData(loginResponseData, setAppDataReturnFunc);
      // 쿠키넣기
      let cookieExpires = new Date();
      cookieExpires.setDate(cookieExpires.getDate() + 180);

      setInitCookies("expires", cookieExpires);

      // cookies.set(
      //   "X-AUTH-TOKEN",
      //   `${loginResponseData.tokenType} ${loginResponseData.accessToken}`,
      //   {
      //     path: "/",
      //     expires: cookieExpires,
      //   }
      // );
      setInitCookies(
        "X-AUTH-TOKEN",
        `${loginResponseData.tokenType} ${loginResponseData.accessToken}`
      );
      // cookies.set("X-REFRESH-TOKEN", `${loginResponseData.refreshToken}`, {
      //   path: "/",
      //   expires: cookieExpires,
      // });

      setInitCookies("X-REFRESH-TOKEN", loginResponseData.refreshToken);

      // cookies.set("no", myDecodedToken.no, {
      //   path: "/",
      //   expires: cookieExpires,
      // });

      setInitCookies("no", loginResponseData.refreshToken);
      setInitCookies("checked", cookies.get("checked") || "true");

      if (loginResponseData.autoToken) {
        // cookies.set("autoToken", `${loginResponseData.autoToken}`, {
        //   path: "/",
        //   expires: cookieExpires,
        // });
        setInitCookies("autoToken", loginResponseData.autoToken);
      }

      let data = "";

      await axios.get("/api/mb/member/my-info").then((res) => {
        data = res.data.data;
        // cookies.set(
        //   "favInfo",
        //   {
        //     defaultTp: data.member.mainTp, //설정에서 세팅하는 tp
        //     visibleTp: data.member.mainTp, //메인 화면에서 변경시키는 tp
        //     favMk: data.member.favMk,
        //     favMt: data.member.favMt,
        //   },
        //   {
        //     path: "/",
        //     expires: cookieExpires,
        //   }
        // );
        setInitCookies(
          "favInfo",
          JSON.stringify({
            defaultTp: data.member.mainTp || 1, //설정에서 세팅하는 tp
            visibleTp: data.member.mainTp || 1, //메인 화면에서 변경시키는 tp
            favMk: data.member.favMk,
            favMt: data.member.favMt,
          })
        );
      });

      window.loginComplete4 = function(authKey, pushUrl) {
        history.push("/");
      };
      if (window.Android) {
        window.Android.login(
          myDecodedToken.no,
          data.tag,
          data.member.mktPushYn,
          "loginComplete4"
        );
      } else if (
        window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.ios
      ) {
        // Call iOS interface
        var message = {
          command: "login",
          id: myDecodedToken.no,
          tag: data.tag,
          adYn: data.member.mktPushYn,
          func: "loginComplete4",
        };
        window.webkit.messageHandlers.ios.postMessage(message);
      }
      history.replace("/");
    }
  }, [loginSuccess]);

  useEffect(() => {
    onReset();
    //app return
    window.joinReturnFunc = (data) => {
      if (data) {
        setReturnData(decodeURI(data));
      }
    };

    //web test
    const receiveMessage = async (e) => {
      if (isJsonString(e.data)) {
        setReturnData(e.data);
      }
    };

    window.addEventListener("message", receiveMessage, false);
  }, []);

  window.appBackKeyHandle = () => {
    if (open) {
      if (mode == "isOrgUser") {
        handleAlreadyUser();
      } else if (mode == "isLev" || mode == "isUser") {
        history.replace("/");
      } else {
        handleAlertClose();
      }
    } else {
      history.goBack();
    }
  };

  return (
    <>
      <div className="layout-flex">
        <div className="layout-body join-body">
          <h3 className="h3">
            휴대폰 본인인증을
            <br />
            진행해주세요
          </h3>

          <Box className="illust" mt={16}>
            <img
              src={`${process.env.PUBLIC_URL}/images/img/illust-login.svg`}
            />
          </Box>
        </div>

        <div className="layout-footer">
          <div className="layout-link">
            <Button
              variant="contained"
              color="primary"
              onClick={() => goCert("joinReturnFunc")}
            >
              휴대폰 인증
            </Button>
          </div>
        </div>
      </div>
      {mode == "isOrgUser" ? (
        <AlertComplete
          open={open}
          handleAlertClose={handleAlreadyUser}
          text={
            "고객님은 이미 메가마트 회원입니다.<br/>추가 정보를 입력하고 회원가입을 완료하세요."
          }
          action={handleAlreadyUser}
        />
      ) : mode == "isLev" ? (
        <AlertComplete
          open={open}
          handleAlertClose={() => history.replace("/")}
          text={
            "현재 고객님은 회원탈퇴 중입니다, 메가마트 멤버십 앱을 사용하시려면 회원탈퇴 7일 후 재가입 해주세요."
          }
          action={() => history.replace("/")}
        />
      ) : mode == "isUser" ? (
        <AlertConfirm
          open={open}
          handleAlertClose={() => history.replace("/")}
          text={
            "고객님은 이미 메가마트 멤버십에 가입된 사용자입니다.<br/>로그인 하시겠습니까?"
          }
          action={() => goLogin(data)}
        />
      ) : (
        <AlertComplete
          open={open}
          handleAlertClose={handleAlertClose}
          text={
            "가까운 매장 안내데스크를 방문하시어 <br/>고객 정보를 수정해주시기 바랍니다."
          }
          action={handleAlertClose}
        />
      )}
    </>
  );
}
